<form [formGroup]="forgotPwdForm" (ngSubmit)="onforgotPwdFormubmit()" #forgotPwdFormHash="ngForm">
    <div class="container-fluid">
        <span *ngIf="!changedPassSuccess" style="color: red;">{{PwdChangeMsg}}</span>
        <div class="user_login">
            <h6 class="use_head">Username</h6>
            <div class="input-group us_grp">
                <input type="text" placeholder="Username" class="inp_us" formControlName="username">
                <span class="input-group-addon"><i class="icon-user ncr_icon"></i></span>
            </div>
            <div style="color: red;"
                *ngIf="forgotPwdForm.get('username').hasError('required') && forgotPwdFormHash.submitted">Username is
                required</div>
        </div>
        <div class="pswd_login">
            <h6 class="use_head">Email Id</h6>
            <div class="input-group us_grp">
                <input type="email" placeholder="Email Id" class="inp_us" formControlName="emailid">
                <span class="input-group-addon"><i class="icon-key ncr_icon"></i></span>
            </div>
            <div style="color: red;"
                *ngIf="forgotPwdForm.get('emailid').hasError('required') && forgotPwdFormHash.submitted">Email is
                required
            </div>
            <div style="color: red;"
                *ngIf="forgotPwdForm.get('emailid').hasError('email') && forgotPwdFormHash.submitted">Email is not
                valid
            </div>
        </div>
        <div class="pswd_login" *ngIf="IsOtpHide">
          <h6 class="use_head">OTP</h6>
          <div class="input-group us_grp">
              <input type="password" placeholder="OTP" class="inp_us" formControlName="OTP">
              <span class="input-group-addon"><i class="icon-key ncr_icon"></i></span>
          </div>
        </div>
        <div class="log_btn">
            <button type="submit" *ngIf="!IsOtpHide" class="btn btn_login">Submit</button>
            <button type="button" (click)="ForgotPasswordWithOTP()" *ngIf="IsOtpHide" class="btn btn_login">Submit</button>
        </div>
    </div>
    <div class="event_head">
        <!--<img src="https://pcknstg.blob.core.windows.net/hdfile/webimg/login_event.png"/>-->

        <a [innerHtml]="BannerURL" class="sidebar-video-container"></a>

    </div>
</form>

<div id="cover" [@ShowHide]="loaderspinning ? 'spinning' : 'stopped'">
        <img src="https://pcknstg.blob.core.windows.net/hdfile/webimg/logo_spin.png" class="img_spin">
</div>
